<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Transcript To HGNC Identifier</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter transcript identifier.</div>
                    <mat-icon
                        matTooltip="Enter your transcript id in the format NM_201628.3. For multiple mappings separate your inputs with a comma. E.g. 'NM_201628.3,NM_001382430.1' or click 'Load Example' to get a basic example."
                        matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter transcript identifier e.g. 'NM_201628.3' or click 'Load Example'"></textarea>
            </div>
            <div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div class="card-grid" *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header"> 
            <h2>{{element.name}}</h2>
        </div>
        <ul *ngIf="element['response']==200">
            <li>HUGO Gene Name: {{element['hgnc']}}</li>
            <li>HGNC ID: {{element['hgnc_id']}}</li>
            <li>NCBI_MANE-Transcript: {{element['ncbi_mane']}}</li>
            <li>Ensembl_MANE-Transcript:  {{element['ensembl_mane']}}</li>
            <!-- <li *ngFor="let item of element | keyvalue">{{item.key}}: {{item.value}}</li> -->
        </ul>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
            <!-- <li *ngFor="let item of element | keyvalue">{{item.key}}: {{item.value}}</li> -->
        </ul>
    </div>
</div>
